import {atom} from "recoil";
import {FormAlertModel} from "../api/types/alert";
import {SelectElementModelFE} from "../api/types/generic";

export const alertsAtom = atom<SelectElementModelFE[]>({
    key: "alerts",
    default: []
});

export const schedulingAtom = atom<SelectElementModelFE[]>({
    key: "scheduling",
    default: []
});

export const unitAtom = atom<SelectElementModelFE[]>({
    key: "unit",
    default: []
});

export const initialFormAlertModel = (t: Function, legalEntityOptions: SelectElementModelFE[], dealerOption: SelectElementModelFE[]): FormAlertModel => ({
    uuid: undefined,
    type: null,
    description: "",
    recipientLists: [],
    locations: [],
    locationGroups: [],
    schedulingType: null,
    dealer: dealerOption.length === 1 ? dealerOption[0] : null,
    legalEntity: legalEntityOptions.length === 1 ? legalEntityOptions[0] : null,
    capacityOfLocations: {
        remainingCapacityDays: 0,
        remainingPercentage: null,
        remainingCapacity: null,
        usagePercentage: null,
        firstRule: t("pricing:alert.labels.rules.capacityOfLocationsRules.firstPartRule1"),
        secondRule: `${t("pricing:alert.labels.rules.capacityOfLocationsRules.firstPartRule2")} ${t("pricing:alert.labels.rules.capacityOfLocationsRules.secondPartRule2")}`
    },
    availabilityOfVehicles: {
        maxDailyBookings: 0,
        securityMargin: 0,
        firstRule: t("pricing:alert.labels.rules.availabilityOfVehicles.firstPartRule1"),
        commercialSegment: null
    },
    competitorsBenchmarks: {
        topPricePosition: 0,
        bottomPricePosition: 0,
        firstRule: t("pricing:alert.labels.rules.competitorsBenchmarks.firstPartRules"),
        secondRule: t("pricing:alert.labels.rules.competitorsBenchmarks.firstPartRules")
    },
    rpd: {
        pickupDateFrom: null,
        pickupDateTo: null,
        minRPD: 0,
        firstRule: t("pricing:alert.labels.rules.rpd.firstPartRule1"),
        commercialSegment: null
    },
    pricingErrors: {
        pickupDateFrom: null,
        pickupDateTo: null,
        minDailyPrice: 0,
        unitType: null,
        firstRule: t("pricing:alert.labels.rules.pricingErrors.firstPartRule1"),
        commercialSegment: null
    },
    advanceBooking: {
        pickupDateFrom: null,
        pickupDateTo: null,
        pastDays: 0,
        pastOrFutureDays: 0,
        averageBookingsNumber: null,
        firstRule: t("pricing:alert.labels.rules.advanceBooking.firstPartRule1"),
        commercialSegment: null
    },
    crons: {
        radioType: "",
        startTime: null,
        addTime: null,
        weeklyDays: [],
        monthlyDays: ""
    }
});